const items = {
  "term.fields.sn.label": "serial",
  "term.fields.word.label": "word",
  "term.fields.description.label": "tags",
  "term.fields.description.tooltip":
    "单词说明，可以用来区分相同拼写的不同单词。",
  "term.fields.channel.label": "channel",
  "term.fields.channel.tooltip": "该术语仅仅用于某个版本",
  "term.fields.meaning.label": "meaning",
  "term.fields.meaning.tooltip": "单词的首选意思",
  "term.fields.meaning2.label": "other meanings",
  "term.fields.meaning2.tooltip": "其他意思将出现在后面的括号里",
  "term.fields.note.label": "note",
  "term.general-in-studio": "general in studio",
};

export default items;
